import type { DataSession } from "../../../data/core/session";
import type { z } from "zod";
import { getQueryKey } from "@trpc/react-query";
import { gamificationSummaryWireSchema } from "@libs/wire";
import { NoAuthError } from "@utils/NoAuthError";
import { RouterOutputs, trpc } from "@utils/trpc";

export type GamificationSummaryQueryData =
  RouterOutputs["user"]["gamification"]["summary"];

type _GamificationSummaryWireSchemaSubset =
  z.infer<
    typeof gamificationSummaryWireSchema
  > extends GamificationSummaryQueryData
    ? true
    : never;
type _GamificationSummaryWireSchemaSuperset =
  GamificationSummaryQueryData extends z.infer<
    typeof gamificationSummaryWireSchema
  >
    ? true
    : never;
const _gamificationSummaryWireSchemaDriftCheck: [
  _GamificationSummaryWireSchemaSubset,
  _GamificationSummaryWireSchemaSuperset,
] = [true, true];
void _gamificationSummaryWireSchemaDriftCheck;

export const gamificationSummaryQueryKey = () =>
  getQueryKey(trpc.user.gamification.summary);

export const gamificationSummaryQuery = (data: DataSession) =>
  data.cache.durableQueryOptions<GamificationSummaryQueryData>({
    queryKey: gamificationSummaryQueryKey(),
    queryFn: () => {
      if (!data.auth.currentUser()) {
        throw new NoAuthError("gamificationSummaryQuery queryFn");
      }
      return data.api.user.gamification.summary.query();
    },
    schema: gamificationSummaryWireSchema,
  });
